import { useState } from 'react';

export const useResetChat = (API_URL) => {
  const [isResetting, setIsResetting] = useState(false);

  const resetChat = async () => {
    if (!API_URL) return;

    setIsResetting(true);
    const resetUrl = `${API_URL}/reset_chat`;

    try {
      const response = await fetch(
          resetUrl,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json',},
            credentials: 'include',
          }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Chat reset successful:', result);
      return true;
    } catch (error) {
      console.error('Error resetting chat:', error);
      return false;
    } finally {
      setIsResetting(false);
    }
  };

  return { resetChat, isResetting };
};
